// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.key-value-items-list {
    height: auto;
    overflow-y: auto;
    background-color: #e5e5e5;
    padding: 5px;
    resize: vertical;
    height: 250px;
}

.key-value-items-list .alert-text {
    overflow: auto;
}

.key-value-items-list .alert {
    line-height: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/common/key-value-list-manager/key-value-list-manager.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".key-value-items-list {\r\n    height: auto;\r\n    overflow-y: auto;\r\n    background-color: #e5e5e5;\r\n    padding: 5px;\r\n    resize: vertical;\r\n    height: 250px;\r\n}\r\n\r\n.key-value-items-list .alert-text {\r\n    overflow: auto;\r\n}\r\n\r\n.key-value-items-list .alert {\r\n    line-height: 30px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
